import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { PageEntityInterface } from '../types/base-entity-interface'
import { PageContentEntities } from '../types/page-interface'

export const findEntityByType = (
  entities: PageContentEntities,
  type: EntityTypeEnum,
): PageEntityInterface | undefined => {
  return Object.values(entities).find(entity => entity.type === type)
}
